import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.every.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.for-each.js";
import "core-js/modules/esnext.iterator.map.js";
import "core-js/modules/esnext.iterator.reduce.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, createVNode as _createVNode, renderList as _renderList, createSlots as _createSlots, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-0fdd579c"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "button-style"
};
const _hoisted_2 = {
  class: "table-column__index-content"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "expand"
}, null, -1));
const _hoisted_4 = {
  class: "index"
};
const _hoisted_5 = {
  key: 0
};
const _hoisted_6 = {
  key: 0,
  style: {
    "display": "inline-block",
    "margin-right": "8px"
  }
};
const _hoisted_7 = {
  key: 0,
  style: {
    "display": "inline-block",
    "margin-right": "4px"
  }
};
const _hoisted_8 = {
  class: "more-opreate"
};
const _hoisted_9 = {
  key: 1,
  class: "footer-style"
};
import { ref, unref, watch, reactive, toRefs, computed, getCurrentInstance, onMounted } from 'vue';
import { $authOperate, priceFormat } from '@/utils/common';
import CommonHead from './CommonHead.vue';
import CommonTableColumn from './CommonTableColumn.vue';
import commonForm from './CommonForm.vue';
import { exportData } from '@/utils/excelAndData/ExportTable.ts';
import _ from 'lodash';
import { odataDateToString } from '@/utils/odataUtilCommon';
import { useI18n } from 'vue-i18n';
const rowKeyMobile = '_rowKey_M';
const scrollbarHeight = 400;
export default /*#__PURE__*/_defineComponent({
  __name: 'CommonTable',
  props: {
    schema: {
      type: Object,
      required: true
    },
    tableSchema: {
      type: Array,
      required: false,
      default: null
    },
    tableUiSchema: {
      type: Object,
      required: true
    },
    tableData: {
      type: Array,
      required: false,
      default: null
    },
    uniqueTableKey: {
      type: String,
      required: false,
      default: ''
    },
    getRowButton: {
      type: Function,
      required: false
    },
    selectionType: {
      type: String,
      required: false
    },
    rowKey: {
      type: String,
      required: true,
      default: 'Iguid'
    },
    labelMode: {
      type: Boolean,
      default: false
    },
    rules: {
      type: Object,
      required: true
    },
    pageSize: {
      type: Number,
      required: false,
      default: 10
    },
    pageNum: {
      type: Number,
      required: false,
      default: 1
    },
    totalCount: {
      type: Number,
      required: false,
      default: 0
    },
    // 是否分页
    showPagination: {
      type: Boolean,
      required: false,
      default: false
    },
    autoPagination: {
      type: Boolean,
      required: false,
      default: false
    },
    loading: {
      type: Boolean,
      required: false,
      default: false
    },
    subTitle: {
      type: String,
      required: false
    },
    labelWidth: {
      type: String,
      required: false,
      default: ''
    },
    selectable: {
      type: Function,
      required: false
    },
    sumColumns: {
      type: Array,
      required: false,
      default: null
    },
    rowClassName: {
      type: Function,
      required: false
    },
    cellClassName: {
      type: Function,
      required: false
    },
    spanMethod: {
      type: Function,
      required: false
    },
    tableHeadStyle: {
      type: Function,
      required: false
    },
    sumColumnFunc: {
      type: Function,
      required: false
    },
    exportButton: {
      type: Boolean,
      required: false,
      default: false
    },
    headMerge: {
      type: Array,
      required: false
    },
    sheetName: {
      type: String,
      required: false
    },
    height: {
      type: [String, Number],
      required: false
    },
    maxHeight: {
      type: [String, Number],
      required: false
    },
    customSummary: {
      type: Function,
      required: false
    },
    triArray: {
      type: Array,
      required: false
    },
    displaySchema: {
      // 移动端需要展示的 schema表头
      type: Array,
      default: []
    },
    hightlightCurrentRow: {
      type: Boolean,
      default: true
    },
    expandRowKeys: {
      type: Array,
      required: false,
      default: null
    },
    defaultExpandAll: {
      type: Boolean,
      required: false,
      default: false
    },
    tableSize: {
      type: String,
      required: false,
      default: 'default'
    },
    oriShows: {
      type: Array,
      required: false
    }
  },
  emits: ['rowControlButtonClick', 'selectionChange', 'pageChange', 'handleRowClick', 'rowClickChange', 'selectHandle', 'select', 'selectAll'],
  setup(__props, {
    expose: __expose,
    emit
  }) {
    const prop = __props;
    const checkedColumn = ref([]);
    const columnVisible = ref(false);
    const {
      t
    } = useI18n();
    const instance = getCurrentInstance();
    const pc = instance?.appContext?.config?.globalProperties?.$pc;
    const currentRow = ref('');
    const innerPageNum = ref(prop.pageNum);
    const innerPageSize = ref(prop.pageSize);
    const innerTotalCount = ref(prop.totalCount);
    const selectedList = reactive([]);
    const tableDataFormRef = ref();
    const dataListRef = ref();
    const tableCommon = reactive({
      tableModel: []
    });
    const filterUiSchema = computed(() => {
      const temp = _.cloneDeep(prop.tableUiSchema || {});
      Object.keys(temp).forEach(key => temp[key].width = '');
      return temp;
    });
    const {
      tableModel
    } = toRefs(tableCommon);
    tableCommon.tableModel = prop.tableData.filter(ob => ob.Operation !== 'D');
    const labelMode = computed(() => {
      if (!pc) return true;
      return prop.labelMode;
    });
    // 是否存在 操作列
    const hasHandlers = computed(() => {
      return !!(prop.getRowButton || prop.tableUiSchema.operation && prop.tableUiSchema.operation.hasCustomBtn);
    });
    const rowButtonList = (row, index) => {
      if (!prop.getRowButton) return;
      return prop.getRowButton(row, index).filter(item => {
        if (item?.auth) {
          return $authOperate(item.auth) || !item;
        }
        return true;
      });
    };
    const rowControlButtonClick = (key, scope) => {
      emit('rowControlButtonClick', key, scope);
    };
    const handleSelectionChange = rows => {
      selectedList.value = rows;
      emit('selectionChange', rows);
    };
    const handleRowChange = (newRow, oldRow) => {
      emit('rowClickChange', newRow, oldRow);
    };
    const expandKeys = ref([]);
    let tableHeight = 0; // 表格的高度
    const handleRowClick = (row, column, event) => {
      emit('handleRowClick', row, column, event);
      if (!pc) {
        // 移动端处理
        if (row[rowKeyMobile] === expandKeys.value[0]) {
          expandKeys.value = [];
        } else {
          // @ts-ignore
          expandKeys.value = [row[rowKeyMobile]];
        }
        tableHeight = getTableHeight();
      }
    };
    const onExpandChange = (changedRow, expandedRow) => {
      if (!pc) {
        expandKeys.value = expandedRow.map(item => item[rowKeyMobile]);
        tableHeight = getTableHeight();
      }
    };
    const validateTable = () => {
      if (!tableDataFormRef.value) return;
      return new Promise((resolve, reject) => {
        tableDataFormRef.value?.validate(valid => {
          resolve(valid);
        });
      });
      // let validateStatus = false
      // tableDataFormRef.value.validate((valid: any) => {
      //   validateStatus = valid
      // })
      // return validateStatus
    };
    const handleSizeChange = val => {
      innerPageSize.value = val;
      emit('pageChange', innerPageNum.value, innerPageSize.value);
    };
    const handleCurrentChange = val => {
      innerPageNum.value = val;
      emit('pageChange', innerPageNum.value, innerPageSize.value);
    };
    const getCurrentRow = row => {
      emit('selectionChange', [row]);
    };
    const clickFunction = scope => {
      if (currentRow.value && scope.row[prop.rowKey] === currentRow.value) {
        // 再次点击选中 则取消选中
        currentRow.value = '';
        emit('selectionChange', []);
      } else {
        currentRow.value = scope.row[prop.rowKey];
        emit('selectionChange', [scope.row]);
      }
    };
    const domainFormatValue = (value, filed) => {
      let text = '';
      if (prop.schema && prop.schema.properties) {
        const listObj = prop.schema.properties[filed].oneOf;
        const res = listObj.filter(e => e.const === value);
        if (res && res.length > 0) {
          text = res[0].title;
        }
      }
      return text;
    };
    // const tableRowClassName = (row) => {
    //   if (row.row.Operation && row.row.Operation === 'D') {
    //     return 'hidden-row'
    //   }
    //   return ''
    // }
    const valueInput = (row, filed, precision) => {
      // 防止删除为空 或不为数字
      if (!row[filed] || isNaN(row[filed])) {
        const zearo = 0;
        row[filed] = zearo.toFixed(precision) + '';
      }
      if (row[filed].split('.').length > 1 && row[filed].split('.')[1].length > precision) {
        const temp = parseInt(10 + new Array(precision).join('0'));
        row[filed] = Math.floor(row[filed] * temp) / temp + '';
      }
    };
    const valueToFixed = (row, filed, precision) => {
      // 防止删除为空 或不为数字
      if (!row[filed] || isNaN(row[filed])) {
        const zearo = 0;
        row[filed] = zearo.toFixed(precision) + '';
      }
      row[filed] = parseFloat(row[filed]).toFixed(precision) + '';
    };
    const clearSelection = () => {
      if (prop.selectionType === 'radio') {
        currentRow.value = '';
      } else {
        dataListRef?.value?.clearSelection();
      }
    };
    const rowSelection = rows => {
      if (prop.selectionType === 'radio') {
        currentRow.value = rows[0][prop.rowKey];
      } else {
        rows.forEach(row => {
          dataListRef?.value?.toggleRowSelection(row, true);
        });
      }
    };
    // const radioRowSelection = (value) => {
    //   currentRow.value = value
    //   const dataTable = tableCommon.tableModel.filter((ob) => ob[prop.rowKey] === value)
    //   emit('selectionChange', dataTable)
    // }
    const toggleAllSelection = () => {
      dataListRef?.value?.toggleAllSelection();
    };
    const toggleRowSelection = (row, type) => {
      dataListRef?.value?.toggleRowSelection(row, type);
    };
    const showOverflowTooltip = item => {
      if (labelMode.value) {
        return true;
      } else if (prop.schema.properties && prop.schema.properties[item] && prop.schema.properties[item].creatable === false) {
        return true;
      }
      return false;
    };
    /**
     * 处理radio的selectable
     * @param row
     */
    const handleSelectRadio = row => {
      if (!prop.selectable) {
        return false;
      }
      if (!prop.selectable(row)) {
        return true;
      }
    };
    const minWidth = item => {
      if (prop.tableUiSchema[item] && prop.tableUiSchema[item].width) {
        return prop.tableUiSchema[item].width;
      } else if (typeof item === 'object' && prop.tableUiSchema[item.key] && prop.tableUiSchema[item.key].width) {
        return prop.tableUiSchema[item.key].width;
      }
      return prop.labelWidth;
    };
    const getSummaries = param => {
      // 传入方法时调用方法
      if (prop.sumColumnFunc) {
        return prop.sumColumnFunc(param);
      }
      if (!prop.sumColumns) {
        return '';
      }
      // fix: 表头合并的情况
      const flatten = tableSchema => {
        return tableSchema.reduce((fields, val) => {
          return fields.concat(val?.children || val);
        }, []);
      };
      const sums = [];
      flatten(prop.tableSchema).forEach((item, index) => {
        let indexColumn = index;
        if (prop.selectionType) {
          indexColumn = indexColumn + 1;
        }
        if (index === 0) {
          sums[index] = t('pc-components-65');
          return;
        }
        if (prop.sumColumns.indexOf(item) < 0) {
          sums[indexColumn] = '';
          return;
        }
        let values = tableDataFun.value.map(item1 => Number(item1[item]));
        if (typeof prop.customSummary === 'function') {
          values = prop.customSummary(values, item, index);
        }
        if (!values.every(value => isNaN(value))) {
          let calcVal = `${values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0)}`;
          sums[indexColumn] = Number(calcVal).toFixed(2);
        } else {
          sums[indexColumn] = 'N/A';
        }
      });
      return sums;
    };
    const commonDateFormatter = value => {
      if (_.isEmpty(value)) {
        return value;
      }
      return odataDateToString(value);
    };
    const exportTableData = () => {
      const data = tableCommon.tableModel.filter(ob => ob.Operation !== 'D');
      const tableData = _.cloneDeep(data);
      // 处理表格值问题， date, price
      const dateTypes = [];
      const priceTypes = [];
      Object.keys(prop.schema.properties).forEach(key => {
        if (prop.schema.properties[key].format === 'date') {
          dateTypes.push(key);
        } else if (prop.schema.properties[key].format === 'price') {
          priceTypes.push(key);
        }
      });
      if (dateTypes.length || priceTypes.length) {
        tableData.forEach(row => {
          dateTypes.forEach(key => row[key] && (row[key] = commonDateFormatter(row[key])));
          priceTypes.forEach(key => row[key] && (row[key] = priceFormat(row[key])));
        });
      }
      const timestamp = new Date().getTime();
      const exportSchema = _.cloneDeep(prop.schema);
      if (prop.oriShows !== undefined) {
        prop.oriShows.forEach(e => {
          if (exportSchema.properties[e]) {
            delete exportSchema.properties[e].oneOf;
          }
        });
      }
      const tableObj = {
        schema: exportSchema,
        tableSchema: prop.tableSchema,
        tableData,
        sheetName: (prop.sheetName ? prop.sheetName : prop.subTitle ? prop.subTitle : t('ops-export')) + '-' + timestamp,
        headMerge: prop.headMerge,
        tableUiSchema: prop.tableUiSchema
      };
      exportData([tableObj], tableObj.sheetName, prop.labelWidth);
    };
    const setSelection = values => {
      let rows = [];
      values.forEach((item, index) => {
        const selectRow = tableCommon.tableModel.filter(ob => ob[prop.rowKey] === item);
        rows = rows.concat(selectRow);
      });
      if (rows && rows.length > 0) {
        rowSelection(rows);
      }
    };
    const clearFiledValidate = filed => {
      tableDataFormRef.value?.clearValidate(filed);
    };
    const resetFields = () => {
      tableDataFormRef.value?.resetFields();
      tableDataFormRef.value?.clearValidate();
    };
    const selectAll = rows => {
      emit('selectAll', rows);
    };
    function openColumn() {
      columnVisible.value = true;
      const sessionColumn = sessionStorage.getItem(prop.uniqueTableKey);
      if (sessionColumn) {
        const columnObj = JSON.parse(sessionColumn);
        checkedColumn.value = columnObj;
      } else {
        checkedColumn.value = displaySchema.value;
      }
    }
    function changeColumn() {
      displaySchema.value = checkedColumn.value;
      sessionStorage.setItem(prop.uniqueTableKey, JSON.stringify(displaySchema.value));
      columnVisible.value = false;
    }
    /*
    移动端仅展示可选的两列数据 -- starts
    **/
    // 判断父组件是否是 dialog
    let isInDialog = false;
    const currentMobileView = 'mobile-view' + Math.random();
    onMounted(() => {
      if (!pc) {
        const parent = document.getElementsByClassName(currentMobileView)[0].parentNode;
        if (parent && parent.className.indexOf('el-dialog__body') >= 0) {
          isInDialog = true;
        }
      }
    });
    const displaySchema = ref([]);
    const expandSchema = ref([]);
    // return 含有slot的schema
    const hasSlot = schema => {
      const hasSlotSchema = [];
      if (!prop.tableUiSchema) {
        return [];
      }
      Object.keys(prop.tableUiSchema).forEach(key => {
        if (prop.tableUiSchema[key].slot && schema.includes(key)) {
          hasSlotSchema.push(key);
        }
      });
      return hasSlotSchema;
    };
    watch(() => prop.tableSchema, newVal => {
      if (newVal && newVal[0]) {
        if (pc) {
          const sessionColumn = sessionStorage.getItem(prop.uniqueTableKey);
          if (sessionColumn) {
            const columnObj = JSON.parse(sessionColumn);
            displaySchema.value = columnObj;
          } else {
            displaySchema.value = newVal;
          }
          return;
        }
        expandSchema.value = newVal.filter(item => !item.key); // 移动端展开内容剔除掉 序号列
        if (prop.displaySchema[0]) {
          displaySchema.value = [...prop.displaySchema];
        } else {
          const temp = newVal.filter(item => {
            if (typeof item === 'object') {
              return !!item.prop; // 剔除 item.key[Xh]列
            } else {
              return !!item;
            }
          });
          // selectedSchema.push(...temp.slice(0, 2))
          displaySchema.value = temp.slice(0, hasHandlers.value || isInDialog ? 1 : 2);
        }
      }
    }, {
      deep: true,
      immediate: true
    });
    watch(() => isInDialog, val => {
      if (val) {
        if (!hasHandlers.value) {
          displaySchema.value.splice(0, 1);
        }
      }
    }, {
      immediate: true
    });
    // 前端分页算法
    const tableDataFun = computed(() => {
      let items = tableCommon.tableModel?.filter(ob => ob.Operation !== 'D');
      // 前端分页情况
      if (items.length > 0 && prop.autoPagination && prop.showPagination) {
        items = items.slice((innerPageNum.value - 1) * innerPageSize.value, innerPageNum.value * innerPageSize.value);
      }
      return items;
    });
    // const tableDataFun = ref([])
    const mobileTableData = ref([]);
    // watch(
    //   () => [tableCommon.tableModel, prop.autoPagination, prop.showPagination, innerPageNum, innerPageSize],
    //   () => {
    //     if (!(tableCommon.tableModel instanceof Array)) return
    //     let items = tableCommon.tableModel.filter((ob) => ob.Operation !== 'D')
    //     // 前端分页情况
    //     if (items.length > 0 && prop.autoPagination && prop.showPagination) {
    //       items = items.slice(
    //         (innerPageNum.value - 1) * innerPageSize.value,
    //         innerPageNum.value * innerPageSize.value
    //       )
    //     }
    //     // if (!pc && mobileTableData.value.length !== 0) {
    //     //   const list = _.cloneDeep(unref(mobileTableData))
    //     //   if (list instanceof Array)
    //     //   // 移动端自定义 rowKey
    //     //   {
    //     //     list.forEach(t=> {
    //     //       delete t[rowKeyMobile]
    //     //     })
    //     //   }
    //     //   tableDataFun.value = list
    //     // } else {
    //       tableDataFun.value = items
    //     // }
    //   },
    //   {
    //     deep: true,
    //     immediate: true
    //   }
    // )
    watch(() => tableDataFun, val => {
      if (!pc) {
        const list = _.cloneDeep(unref(val));
        if (list instanceof Array) {
          // 移动端自定义 rowKey
          list.forEach((t, i) => {
            t[rowKeyMobile] = i;
          });
        }
        mobileTableData.value = list;
      }
    }, {
      deep: true,
      immediate: true
    });
    /*
    移动端仅展示可选的两列数据 -- ends
    **/
    /*
    移动端滚动
    **/
    let scrollCurrent = 0; // 判断滚动方向
    let isPrevent = false; // 节流
    const onScrollBarScroll = ({
      scrollTop
    }) => {
      if (pc) return;
      if (prop.autoPagination) return;
      if (!tableHeight) {
        tableHeight = getTableHeight();
      }
      if (scrollTop >= scrollCurrent) {
        if (!isPrevent) {
          if (tableHeight - (scrollTop + scrollbarHeight) <= 10) {
            emit('pageChange', innerPageNum.value, innerPageSize.value);
            handleCurrentChange(innerPageNum.value++);
            isPrevent = true;
          }
        }
      } else {
        isPrevent = false;
      }
      scrollCurrent = scrollTop;
    };
    function getTableHeight() {
      const el = dataListRef.value.$el;
      return el.offsetHeight;
    }
    function handleSelect(selection, row) {
      emit('selectHandle', selection, row);
    }
    watch(() => prop.pageSize, newVal => {
      if (newVal) {
        innerPageSize.value = newVal;
      }
    }, {
      deep: true
    });
    watch(() => prop.pageNum, newVal => {
      if (newVal) {
        innerPageNum.value = newVal;
      }
    }, {
      deep: true
    });
    watch(() => prop.totalCount, newVal => {
      if (newVal >= 0) {
        innerTotalCount.value = newVal;
      }
    }, {
      deep: true
    });
    watch(() => prop.tableData, newVal => {
      if (newVal) {
        tableModel.value = newVal;
        // 前端分页
        if (prop.autoPagination && prop.showPagination) {
          innerTotalCount.value = tableModel.value ? tableModel.value.length : 0;
        }
      }
    }, {
      immediate: true,
      deep: false
    });
    watch(() => prop.expandRowKeys, newVal => {
      if (newVal && newVal.length > 0) {
        expandKeys.value = prop.expandRowKeys;
      }
    }, {
      deep: true
    });
    __expose({
      validateTable,
      clearSelection,
      selectedList,
      rowSelection,
      toggleAllSelection,
      exportTableData,
      toggleRowSelection,
      setSelection,
      getSummaries,
      resetFields,
      clearFiledValidate,
      innerPageSize,
      innerPageNum,
      getSelectionRows() {
        return dataListRef?.value?.getSelectionRows();
      }
    });
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_radio = _resolveComponent("el-radio");
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_link = _resolveComponent("el-link");
      const _component_el_popconfirm = _resolveComponent("el-popconfirm");
      const _component_more_filled = _resolveComponent("more-filled");
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_popover = _resolveComponent("el-popover");
      const _component_el_table = _resolveComponent("el-table");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_pagination = _resolveComponent("el-pagination");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(_unref(pc) ? 'pc-view' : `mobile-view ${currentMobileView}`),
        style: {
          "width": "100%"
        }
      }, [__props.subTitle ? (_openBlock(), _createBlock(CommonHead, {
        key: 0,
        title: _ctx.$t(__props.subTitle)
      }, {
        default: _withCtx(() => [_renderSlot(_ctx.$slots, "batchControl"), __props.exportButton ? (_openBlock(), _createBlock(_component_el_button, {
          key: 0,
          type: "primary",
          onClick: exportTableData
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('ops-export')), 1)]),
          _: 1
        })) : _createCommentVNode("", true)]),
        _: 3
      }, 8, ["title"])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_1, [!__props.subTitle && _ctx.$slots.batchControl ? _renderSlot(_ctx.$slots, "batchControl", {
        key: 0
      }) : _createCommentVNode("", true), __props.exportButton ? (_openBlock(), _createBlock(_component_el_button, {
        key: 1,
        type: "primary",
        onClick: exportTableData
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('ops-export')), 1)]),
        _: 1
      })) : _createCommentVNode("", true)]), _createVNode(_component_el_form, {
        model: tableDataFun.value,
        ref_key: "tableDataFormRef",
        ref: tableDataFormRef,
        rules: __props.rules,
        size: __props.tableSize,
        "show-message": true
      }, {
        default: _withCtx(() => [__props.schema ? _withDirectives((_openBlock(), _createBlock(_component_el_table, {
          key: 0,
          ref_key: "dataListRef",
          ref: dataListRef,
          "scrollbar-always-on": "true",
          data: _unref(pc) ? tableDataFun.value : mobileTableData.value,
          "summary-method": getSummaries,
          "show-summary": __props.sumColumns ? true : false,
          "row-class-name": __props.rowClassName,
          "cell-class-name": __props.cellClassName,
          "span-method": __props.spanMethod,
          "element-loading-text": _ctx.$t('msg-loading'),
          border: "",
          fit: "",
          "highlight-current-row": __props.hightlightCurrentRow,
          "header-cell-style": __props.tableHeadStyle,
          "row-key": _unref(pc) ? __props.rowKey : rowKeyMobile,
          size: __props.tableSize,
          onRowClick: handleRowClick,
          onSelectionChange: handleSelectionChange,
          onCurrentChange: handleRowChange,
          onSelectAll: selectAll,
          height: __props.height,
          "max-height": _unref(_).isEmpty(__props.maxHeight) ? 500 : __props.maxHeight,
          "expand-row-keys": expandKeys.value,
          onExpandChange: onExpandChange,
          onSelect: handleSelect,
          "default-expand-all": __props.defaultExpandAll
        }, {
          default: _withCtx(() => [__props.selectionType && __props.selectionType === 'radio' && _unref(pc) ? (_openBlock(), _createBlock(_component_el_table_column, {
            key: 0,
            selectable: __props.selectable,
            "reserve-selection": true,
            fixed: "",
            label: "",
            align: "center",
            width: "55px",
            type: ""
          }, {
            default: _withCtx(scope => [_createVNode(_component_el_radio, {
              style: {
                "margin-left": "9px"
              },
              label: scope.row[__props.rowKey],
              modelValue: currentRow.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => currentRow.value = $event),
              disabled: handleSelectRadio(scope.row),
              onClick: _withModifiers($event => clickFunction(scope), ["prevent"])
            }, {
              default: _withCtx(() => [_createTextVNode("  ")]),
              _: 2
            }, 1032, ["label", "modelValue", "disabled", "onClick"])]),
            _: 1
          }, 8, ["selectable"])) : _createCommentVNode("", true), __props.selectionType && __props.selectionType === 'checkbox' && _unref(pc) ? (_openBlock(), _createBlock(_component_el_table_column, {
            key: 1,
            selectable: __props.selectable,
            "reserve-selection": true,
            fixed: "",
            align: "center",
            type: "selection",
            width: "55px"
          }, null, 8, ["selectable"])) : _createCommentVNode("", true), !_unref(pc) && displaySchema.value.length > 0 ? (_openBlock(), _createBlock(_component_el_table_column, {
            key: 2,
            fixed: "",
            label: "",
            align: "center",
            width: "-1",
            "class-name": "table-column-expand",
            type: "expand"
          }, {
            default: _withCtx(scope => [_createVNode(commonForm, {
              schema: __props.schema,
              formSchema: expandSchema.value,
              "form-ui-schema": __props.tableUiSchema,
              formData: scope.row,
              "label-mode": labelMode.value,
              labelWidth: "160px"
            }, _createSlots({
              _: 2
            }, [_renderList(hasSlot(expandSchema.value), t => {
              return {
                name: t,
                fn: _withCtx(() => [_renderSlot(_ctx.$slots, t, {
                  row: scope.row,
                  column: scope.column,
                  index: scope.index,
                  form: scope.row
                })])
              };
            })]), 1032, ["schema", "formSchema", "form-ui-schema", "formData", "label-mode"])]),
            _: 3
          })) : _createCommentVNode("", true), !_unref(pc) && displaySchema.value.length > 0 && tableDataFun.value.length > 0 ? (_openBlock(), _createBlock(_component_el_table_column, {
            key: 3,
            type: "index",
            width: "40px"
          }, {
            default: _withCtx(scope => [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("div", _hoisted_4, _toDisplayString(scope.$index + 1), 1)])]),
            _: 1
          })) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(displaySchema.value, (item, index) => {
            return _openBlock(), _createBlock(CommonTableColumn, {
              key: index,
              column: item,
              schema: __props.schema,
              tableUiSchema: _unref(pc) ? __props.tableUiSchema : filterUiSchema.value,
              labelMode: labelMode.value,
              rules: __props.rules,
              labelWidth: __props.labelWidth,
              triArray: __props.triArray
            }, _createSlots({
              _: 2
            }, [_renderList(displaySchema.value, (item, index1) => {
              return {
                name: item,
                fn: _withCtx(scope => [__props.tableUiSchema[item] && __props.tableUiSchema[item].slot ? _renderSlot(_ctx.$slots, item, {
                  key: 0,
                  row: scope.row,
                  column: scope.column,
                  index: scope.index,
                  form: scope.row,
                  fixed: __props.tableUiSchema[item].fixed
                }) : _createCommentVNode("", true)])
              };
            })]), 1032, ["column", "schema", "tableUiSchema", "labelMode", "rules", "labelWidth", "triArray"]);
          }), 128)), hasHandlers.value ? (_openBlock(), _createBlock(_component_el_table_column, {
            key: 4,
            width: __props.tableUiSchema['operation'] && __props.tableUiSchema['operation'].width ? __props.tableUiSchema['operation'].width : __props.labelWidth,
            fixed: "right",
            label: _ctx.$t('ops-operation'),
            align: "center"
          }, {
            default: _withCtx(scope => [_renderSlot(_ctx.$slots, "customBtn", {
              row: scope.row,
              column: scope.column,
              index: scope.index
            }), __props.getRowButton ? (_openBlock(), _createElementBlock("div", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rowButtonList(scope.row, scope.$index), (item, index) => {
              return _openBlock(), _createElementBlock(_Fragment, {
                key: index
              }, [index < 3 ? (_openBlock(), _createElementBlock("div", _hoisted_6, [!item.tip ? (_openBlock(), _createBlock(_component_el_link, {
                key: 0,
                type: item.disabled ? 'text' : 'primary',
                underline: false,
                disabled: item.disabled ? item.disabled : false,
                onClick: _withModifiers($event => rowControlButtonClick(item.key, scope), ["stop"])
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t(item.label)), 1)]),
                _: 2
              }, 1032, ["type", "disabled", "onClick"])) : (_openBlock(), _createBlock(_component_el_popconfirm, {
                key: 1,
                title: _ctx.$t(item.tip),
                onConfirm: $event => rowControlButtonClick(item.key, scope)
              }, {
                reference: _withCtx(() => [_createVNode(_component_el_button, {
                  type: "text",
                  disabled: item.disabled ? item.disabled : false
                }, {
                  default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t(item.label)), 1)]),
                  _: 2
                }, 1032, ["disabled"])]),
                _: 2
              }, 1032, ["title", "onConfirm"]))])) : _createCommentVNode("", true)], 64);
            }), 128)), rowButtonList(scope.row, scope.$index).length > 3 ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_createVNode(_component_el_popover, {
              placement: "bottom",
              width: 30,
              trigger: "hover"
            }, {
              reference: _withCtx(() => [_createVNode(_component_el_icon, {
                class: "more-icon",
                color: "#409eff",
                style: {
                  "margin-left": "10px",
                  "cursor": "pointer"
                }
              }, {
                default: _withCtx(() => [_createVNode(_component_more_filled)]),
                _: 1
              })]),
              default: _withCtx(() => [_createElementVNode("div", _hoisted_8, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rowButtonList(scope.row, scope.$index).splice(3), (item, index) => {
                return _openBlock(), _createElementBlock("div", {
                  key: index
                }, [!item.tip ? (_openBlock(), _createBlock(_component_el_link, {
                  key: 0,
                  type: item.disabled ? 'text' : 'primary',
                  underline: false,
                  disabled: item.disabled ? item.disabled : false,
                  onClick: $event => rowControlButtonClick(item.key, scope)
                }, {
                  default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t(item.label)), 1)]),
                  _: 2
                }, 1032, ["type", "disabled", "onClick"])) : (_openBlock(), _createBlock(_component_el_popconfirm, {
                  key: 1,
                  title: _ctx.$t(item.tip),
                  onConfirm: $event => rowControlButtonClick(item.key, scope)
                }, {
                  reference: _withCtx(() => [_createVNode(_component_el_button, {
                    type: "text",
                    disabled: item.disabled ? item.disabled : false
                  }, {
                    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t(item.label)), 1)]),
                    _: 2
                  }, 1032, ["disabled"])]),
                  _: 2
                }, 1032, ["title", "onConfirm"]))]);
              }), 128))])]),
              _: 2
            }, 1024)])) : _createCommentVNode("", true)])) : _createCommentVNode("", true)]),
            _: 3
          }, 8, ["width", "label"])) : _createCommentVNode("", true)]),
          _: 3
        }, 8, ["data", "show-summary", "row-class-name", "cell-class-name", "span-method", "element-loading-text", "highlight-current-row", "header-cell-style", "row-key", "size", "height", "max-height", "expand-row-keys", "default-expand-all"])), [[_directive_loading, __props.loading]]) : _createCommentVNode("", true)]),
        _: 3
      }, 8, ["model", "rules", "size"]), __props.showPagination && _unref(pc) ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_createVNode(_component_el_pagination, {
        onSizeChange: handleSizeChange,
        onCurrentChange: handleCurrentChange,
        "current-page": innerPageNum.value,
        "page-sizes": [5, 10, 50, 100, 200],
        "page-size": innerPageSize.value,
        layout: "total, sizes, prev, pager, next, jumper",
        total: innerTotalCount.value
      }, null, 8, ["current-page", "page-size", "total"])])) : _createCommentVNode("", true)], 2);
    };
  }
});